import { createSlice } from "@reduxjs/toolkit";

interface IinitialState {
  loading: boolean;
  message: string;
  listagemDeVariavel: number[];
  nivelSelecionado: number;
}

export const initialState: IinitialState = {
  loading: false,
  message: "",
  listagemDeVariavel: [],
  nivelSelecionado: 0,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    appLoading: (state, action) => {
      state.loading = action.payload;
    },
    appMessage: (state, action) => {
      state.message = action.payload;
    },
    appListagemDeVariavel: (state, action) => {
      state.listagemDeVariavel = action.payload;
    },
    appNivelSelecionado: (state, action) => {
      state.nivelSelecionado = action.payload;
    },
  },
});

export const {
  appLoading,
  appMessage,
  appListagemDeVariavel,
  appNivelSelecionado,
} = appSlice.actions;

export default appSlice.reducer;
